/**
 * @generated SignedSource<<e8e826b6282ff58a82538442aad20e62>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type GithubIntegrationOutboundIpsQuery$variables = Record<PropertyKey, never>;
export type GithubIntegrationOutboundIpsQuery$data = {
  readonly outboundIpAddresses: ReadonlyArray<string>;
};
export type GithubIntegrationOutboundIpsQuery = {
  response: GithubIntegrationOutboundIpsQuery$data;
  variables: GithubIntegrationOutboundIpsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "outboundIpAddresses",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "GithubIntegrationOutboundIpsQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "GithubIntegrationOutboundIpsQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "7acd42f402dde927ab08b169a1b0558a",
    "id": null,
    "metadata": {},
    "name": "GithubIntegrationOutboundIpsQuery",
    "operationKind": "query",
    "text": "query GithubIntegrationOutboundIpsQuery {\n  outboundIpAddresses\n}\n"
  }
};
})();

(node as any).hash = "d98a281692483bfdd3c81edf7875dce0";

export default node;
